// extracted by mini-css-extract-plugin
module.exports = {"image":"malt-image-Image-image-a6b0ca11"};